import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const DeviceDemographics = ({ data }) => {
  const getDeviceIcon = (device) => {
    switch (device?.toLowerCase()) {
      case 'desktop':
        return 'Monitor';
      case 'mobile':
        return 'Smartphone';
      case 'tablet':
        return 'Tablet';
      default:
        return 'HelpCircle';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        Device Demographics
      </h3>
      <div className="w-full h-48 md:h-64" aria-label="Device demographics bar chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="device" 
              stroke="var(--color-muted-foreground)" 
              style={{ fontSize: '12px' }} 
            />
            <YAxis 
              stroke="var(--color-muted-foreground)" 
              style={{ fontSize: '12px' }} 
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-popover)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Bar 
              dataKey="count" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]} 
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      {/* Device breakdown list */}
      <div className="mt-4 space-y-2">
        {data?.map((item, index) => (
          <div key={index} className="flex items-center justify-between py-2 border-b border-border last:border-0">
            <div className="flex items-center gap-2">
              <Icon name={getDeviceIcon(item?.device)} size={16} className="text-muted-foreground" />
              <span className="text-sm text-foreground">{item?.device}</span>
            </div>
            <span className="text-sm font-medium text-foreground">{item?.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeviceDemographics;